import React, { FC } from "react";
import { Props } from "./types";
import * as S from "./styles";

const GuidancePlanCard: FC<Props> = ({
  handleGoToPayments,
  price,
  isFreeUser,
}) => {
  return (
    <S.PricingCard>
      <S.PricingCardHeader>
        {isFreeUser && (
          <S.PricingBadge>
            <S.PricingBadgeText>PROFESSIONAL</S.PricingBadgeText>
          </S.PricingBadge>
        )}
        <S.PricingCardTitle>CareerFit Guidance</S.PricingCardTitle>
      </S.PricingCardHeader>
      <S.PricingCardBody>
        <S.PriceSection>
          <S.PriceWrapper>
            <S.PriceAmount>{price}</S.PriceAmount>
            <S.PriceCurrency>€</S.PriceCurrency>
          </S.PriceWrapper>
          <S.CheckItem>
            <S.CheckIcon>
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                  fill="#f6921e"
                />
              </svg>
            </S.CheckIcon>
            <S.CheckText>One-time payment</S.CheckText>
          </S.CheckItem>
          {isFreeUser && (
            <S.CheckItem>
              <S.CheckIcon>
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                    fill="#f6921e"
                  />
                </svg>
              </S.CheckIcon>
              <S.CheckText>Includes CareerFit Essentials</S.CheckText>
            </S.CheckItem>
          )}
          <S.CheckItem>
            <S.CheckIcon>
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                  fill="#f6921e"
                />
              </svg>
            </S.CheckIcon>
            <S.CheckText>Includes 2 expert sessions</S.CheckText>
          </S.CheckItem>
        </S.PriceSection>
        {isFreeUser && (
          <S.PricingDescription>
            Ongoing guidance to make confident career decisions.
          </S.PricingDescription>
        )}
        <S.IncludedSection>
          <S.IncludedTitle>What&rsquo;s included</S.IncludedTitle>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Two 45 minute guidance counselling sessions
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Deep Dive Career Counselling to explore motivations, values and
              long term ambitions
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Narrow down IDEAL Career options for your unique mix of interests
              and abilities
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Begin shaping your Personalised CareerFit Action Plan
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Review your CareerFit Action Plan to adjust and refine after
              reflection period
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Identify next steps, opportunities & commitments
            </S.IncludedText>
          </S.IncludedItem>
        </S.IncludedSection>
      </S.PricingCardBody>
      <S.PricingCardFooter>
        <S.PricingButton onClick={() => handleGoToPayments("guidance")}>
          Book Guidance Session
        </S.PricingButton>
      </S.PricingCardFooter>
    </S.PricingCard>
  );
};

export default GuidancePlanCard;
